<template>
  <div class="home">
    <div class="headera">
      <!-- <img
        src="../assets/org/icon_back.png"
        alt=""
        class="goBack"
        @click="goBack"
      /> -->
      <!-- <div class="tipsBox"> -->
      <div class="back">
        <span class="tips" @click="gotopage('home')">首页</span>
        <span class="tips" @click="gotopage('site')">区域</span>
      </div>
      <div class="datetime">
        <el-select
          v-model="orgId"
          placeholder=""
          @change="seleorg"
        >
          <el-option
            v-for="item in orgData"
            :key="item.id"
            :label="item.branchName"
            :value="item.branchId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="stationSelect">
        <el-select
          v-model="stationModel"
          placeholder=""
          @change="selStation"
        >
          <el-option
            v-for="item in stationData"
            :key="item.branchId"
            :label="item.branchName"
            :value="item.branchId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="logo">
        {{ titleName }}
      </div>

      <!-- </div> -->
    </div>
    <div class="main">
      <div class="mainTop">
        <div class="maTopInfo1">
          <div class="inItem1">
            <img src="../assets/newicon/lrxx.png" alt="" class="smtopImg1" />
            <div class="infoValue1">
              <p class="topNum1">{{topinfoArr[0].typeName }}</p>
              <p class="topNum" v-for="(item1, index1) in topinfoArr[0].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem1">
            <img src="../assets/newicon/ylsm.png" alt="" class="smtopImg1" />
            <div class="infoValue1">
              <p class="topNum1">{{topinfoArr[1].typeName }}</p>
              <p class="topNum" v-for="(item1, index1) in topinfoArr[1].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem1" >
            <img src="../assets/newicon/zdll.png" alt="" class="smtopImg1" />
            <div class="infoValue1">
              <p class="topNum1">{{topinfoArr[2].typeName }}</p>
              <p class="topNum" v-for="(item1, index1) in topinfoArr[2].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
          <div class="inItem1" >
            <img src="../assets/newicon/gyhd.png" alt="" class="smtopImg1" />
            <div class="infoValue1">
              <p class="topNum1">{{topinfoArr[3].typeName }}</p>
              <p class="topNum" v-for="(item1, index1) in topinfoArr[3].dataList" :key="index1">
                <span>{{ item1.dataSubCodeName }}</span
                ><span>{{ item1.dataValue }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="institutionInfo1">
        <div class="city1">{{ titleName }}</div>
        <div class="listBox" v-if="institution.length > 0">
          <div
            class="listItem"
            v-for="(item, index) in institution"
            :key="index"
          >
            <template v-if="item.name == 3">
              <img src="../assets/site/jigou.png" alt="" />
              <span style="margin-left: 20px">养老机构：</span>
            </template>
            <template v-if="item.name == 2">
              <img src="../assets/site/zhandian.png" alt="" />
              <span style="margin-left: 20px">中心站点：</span>
            </template>
            <template v-if="item.name == 1">
              <img src="../assets/site/yiyuan.png" alt="" />
              <span style="margin-left: 20px">社区站点：</span>
            </template>
            <span>{{ item.num }}</span>
          </div>
        </div>
      </div>
      <div class="mainBottom">
        <div class="mainBoLeft">
          <div id="mapContainer"></div>
        </div>
        <div class="mainBoRight">
          <div class="rimgItem">
            <swiper
              :options="swiperOption"
              @slideChangeTransitionEnd="onSlideChange"
            >
              <swiper-slide v-for="item in imgList" :key="item.id">
                <div class="swipercon">
                  <img
                    class="pic"
                    :src="`/ophApi/commonAttachDown/download?id=${item.id}`"
                    alt=""
                  />
                  <p>{{ item.title}}</p>
                </div>

              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <img src="../assets/area/xiaokuang.png" alt="" class="bgimg" />
          </div>
          <!-- <div class="rimgItem">
            <swiper
              :options="swiperOption"
              @slideChangeTransitionEnd="onSlideChange"
            >
              <swiper-slide v-for="item in imgList2" :key="item.id">
                <img
                  :src="`/ophApi/commonAttachDown/download?id=${item.id}`"
                  alt=""
                />
              </swiper-slide>

              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
            <img src="../assets/area/xiaokuang.png" alt="" class="bgimg" />
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import Hls from 'hls.js'
// import moment from 'moment'
// import Highcharts from 'highcharts'
// import mapStyleJson from "./map-style-json.js";
import mapStyleJson from './custom_map_config.json'
export default {
  name: '',
  data () {
    return {
      city: '',
      orgInfo: {},
      swiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        autoplay: {
          delay: 2000
        }
      },
      imgList: [],
      imgList2: [],
      institution: [],
      insId: '',
      areainfo: [],
      topinfo: {
        adapteToAging: null,
        intelligentConfig: null,
        homeCareSignUp: null,
        dayCareService: null,
        respiteCareService: null,
        selfOperatedSite: null,
        regulatorySite: null,
        mealAid: null,
        bathAid: null,
        medicalAid: null
      },
      titleName: '',
      menuData: null,
      topinfoArr: [],
      orgId: '',
      orgData: [],
      stationData: [],
      stationModel: null
    }
  },
  created () {
    this.city = this.$route.query.city * 1
    this.insId = this.$route.query.insId * 1
    this.orgId = this.$route.query.orgId
    console.log(this.city, this.insId, this.orgId)
    this.getinfo()
  },
  mounted () {
    var that = this
    this.$nextTick(async () => {
      const data = that.mapinfo
      var map = new BMapGL.Map('mapContainer')
      map.centerAndZoom(
        new BMapGL.Point(data[0].longitude, data[0].latitude),
        18
      )
      map.setMapStyleV2({ styleJson: mapStyleJson })
      map.enableScrollWheelZoom(true)
      data.forEach((e, i) => {
        var pt = new BMapGL.Point(e.longitude, e.latitude)
        if (e.orgPropertyType == 1) {
          var icons = require('../assets/site/yiyuan.png')
          var myIcon = new BMapGL.Icon(
            icons,
            new BMapGL.Size(32, 38), // 视窗大小
            {
              imageSize: new BMapGL.Size(32, 38), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
        } else if (e.orgPropertyType == 2) {
          var icons = require('../assets/site/zhandian.png')
          var myIcon = new BMapGL.Icon(
            icons,
            new BMapGL.Size(36, 56), // 视窗大小
            {
              imageSize: new BMapGL.Size(36, 65), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
        } else if (e.orgPropertyType == 3) {
          var icons = require('../assets/site/jigou.png')
          var myIcon = new BMapGL.Icon(
            icons,
            new BMapGL.Size(64, 68), // 视窗大小
            {
              imageSize: new BMapGL.Size(64, 68), // 显示图标大小(根据实际大小等比例缩放)
              imageOffset: new BMapGL.Size(0, 0) // 图片相对视窗的偏移
            }
          )
        }
        var content = e.branchName
        var label = new BMapGL.Label(content, {
          // 创建文本标注
          position: pt,
          offset: new BMapGL.Size(10, 20)
        })
        label.setStyle({
          // 设置label的样式
          color: '#fff',
          fontSize: '16px',
          border: '2px solid #1E90FF',
          backgroundColor: '#0066ff'
        })
        var maker = new BMapGL.Marker(pt, { icon: myIcon }) // 创建标注
        // 点标记添加点击事件
        if (e.orgPropertyType == 1) {
          maker.addEventListener('click', function () {
            console.log('社区站点')
            var info = JSON.stringify(data[i])
            that.$router.push({
              name: 'station',
              query: {
                info: info,
                city: that.city,
                insId: that.insId,
                orgId: that.orgId
              }
            })
          })
        } else if (e.orgPropertyType == 2) {
          maker.addEventListener('click', function () {
            console.log('中心站点')
          })
        } else if (e.orgPropertyType == 3) {
          maker.addEventListener('click', function () {
            console.log('养老机构')
            // this.$router.push('org')
            // console.log( that.$router.push('org'));
          })
        }

        map.addOverlay(maker)
        map.addOverlay(label)
      })
    })
  },
  methods: {
    seleorg (val) {
      var infoList = JSON.parse(localStorage.homeInfos)
      var city = this.city
      infoList[city].children.forEach((item, index) => {
        if (item.branchId === val) {
          this.$router.push({
            name: 'org',
            query: {
              city: this.city,
              id: index
            }
          })
        }
      })
    },
    selStation (val) {
      const that = this
      this.stationData.forEach((item, i) => {
        if (item.branchId === val) {
          that.$router.push({
            name: 'station',
            query: {
              info: JSON.stringify(item),
              city: that.city,
              insId: that.insId,
              orgId: that.orgId
            }
          })
        }
      })
    },
    getinfo () {
      const that = this
      var infoList = JSON.parse(localStorage.homeInfos)
      console.log(infoList, 'infoList')
      var city = this.city
      var insId = this.insId
      var infoData = infoList[city].children[insId]

      this.titleName = infoData.branchName // 标题
      this.mapinfo = infoData.children // 站点地图数据
      this.institution = this.repetition(infoData.children) // 下拉数据

      this.orgData = infoList[city].children.filter(item => item.orgPropertyType != 1)// 去除站点

      var infovalue = infoData.children
      console.log(infoData, 'infoData')
      console.log(infovalue, 'infovalue')
      if (infovalue.length > 0) {
        var data = []
        infovalue[0].children.forEach((element, i) => {
          var object = {
            id: i,
            branchName: element.branchName,
            children: [],
            branchId: element.branchId
          }
          data.push(object)
        })
        this.menuData = data
      }
      that.stationData = []
      this.mapinfo.forEach((item, i) => {
        // 社区
        if (item.orgPropertyType === 1) {
          that.stationData.push(item)
        }
      })

      if (infovalue !== null && infovalue.length > 0) {
        let arr = infoData.siteBaseInfo.groupDataList
        if (infoData.orgPropertyType === 2) { // 中心站点
          arr = infoData.centralSiteBaseInfo.groupDataList
        }
        // let arr = infovalue[0].siteBaseInfo.groupDataList;
        this.topinfoArr = arr.slice(0, 4)
        // this.topinfoArr = arr.slice(0,4)
        console.log(this.topinfoArr)

        // this.topinfo = infovalue[0].centralSiteBaseInfo;
        // this.titleName = infovalue[0].branchName;
        // this.imgList = infovalue[0].honorWallList
        this.imgList = infoData.honorWallList
        // this.arrayChunk(infovalue[0].honorWallList);
        // this.mapinfo = infovalue[0].children;
        // var institut = this.repetition(infovalue[0].children);
        // this.institution = institut;
        // console.log(institut)
      }

      // this.infoData = infoData;
    },
    goBack () {
      history.back()
    },
    gotopage (value) {
      console.log(value)
      this.$router.push({
        name: value,
        query: {
          city: this.city,
          insId: this.insId
        }
      })
    },
    onSlideChange ($swiper) {
      // console.log($swiper.activeIndex);
    },
    arrayChunk (array) {
      if (array && array.length > 3) {
        const data = []
        for (let i = 0; i < array.length; i += 2) {
          data.push(array.slice(i, i + 2))
        }
        this.imgList = data[0]
        this.imgList2 = data[1]
        return data
      } else {
        this.imgList = [] || array
        this.imgList2 = [] || array
      }
    },
    repetition (arr) {
      if (arr) {
        var newArr = [...new Set(arr.map((i) => i.orgPropertyType))] // 去重的时候需要注意和普通数组不同
        var list = []
        newArr.forEach((i) => {
          list.push(arr.filter((t) => t.orgPropertyType === i))
        })

        var mlist = []
        list.forEach((i, index) => {
          mlist.push({
            name: newArr[index],
            num: i.length
          })
        })

        return mlist
      } else {
        return []
      }
    }
  },
  computed: {},
  beforeDestroy () {}
}
</script>
<style lang="scss" scoped>
.swipercon{
  height: 100%;
  position: relative;
  .pic{
    width: 100%;
    height: 100%;
  }
  p{
    width: 100%;
    height: 40px;
    position: absolute;
    bottom: 0;
    left: 0;
    line-height: 40px;
    text-align: center;
    font-size: 24px;
  }
}
.home {
  width: 1920px;
  height: 1080px;
  background: url("../assets/home/bg.jpg");
}
.headera {
  width: 100%;
  height: 116px;
  background: url("../assets/home/logokuang.png") no-repeat;
  background-position: center bottom;
  position: relative;
  display: flex;
  align-items: center;
}
.logo {
  width: 100%;
  line-height: 116px;
  font-size: 34px;
  color: #08fbfb;
  //margin-left: 12px;
  position: absolute;
  top: 0;
  left: 0;
}
.goBack {
  position: absolute;
  width: 55px;
  height: 42px;
  left: 50px;
  top: 20px;
  cursor: pointer;
}
.main {
  padding: 0 !important;
  display: block !important;
  height: calc(100% - 116px);
}
.mainTop {
  width: 100%;
  height: 180px;
  background: url("../assets/area/bjzs.png") no-repeat;
  /* position: relative; */
  z-index: 1;
}
.maTopInfo1 {
  width: 100%;
  height: 85%;
  z-index: 2;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-top: 10px;
}
.inItem1 {
  width: 25%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.smtopImg1 {
  width: 62px;
  height: 72px;
}
.infoValue1 {
  margin-left: 15px;
}

.topNum1 {
  text-align: left;
  font-size: 22px;
  padding: 0;
  margin: 0;
}
.topNum {
  text-align: left;
  color: #f7f489;
}
.topNum span {
  font-size: 14px;
  text-align: left;
}
.topNum span:nth-child(2) {
  color: #ffdf25;
  font-weight: bolder;
  font-size: 18px;
  margin-left: 5px;
}
.mainBottom {
  width: 90%;
  height: 680px;
  margin: 0 auto;
  display: flex;
  margin-top: 20px;
}
.mainBoLeft {
  flex: 6;
  height: 100%;
  position: relative;
  background: url("../assets/area/dakuang.png") no-repeat;
  background-size: 100% 99%;
}
#mapContainer {
  position: absolute;
  width: 95%;
  height: 90%;
  left: 25px;
  top: 18px;
}
.institutionInfo1 {
  width: 300px;
  margin-left: 110px;
  cursor: pointer;
}
.institutionInfo1:hover .listBox {
  display: block;
}
.bgimg {
  position: absolute;
  width: 97%;
  height: 98%;
  right: 0;
  top: 0;
  z-index: 1;
}
.mainBoRight {
  flex: 3;
  overflow: hidden;
}
.rimgItem {
  width: 100%;
  height: 100%;
  position: relative;
}
.swiper-container {
  position: relative;
  width: 90%;
  height: 87%;
  top: 4%;
  left: 1%;
}
.swiper-slide {
  background-color: #fff;
  color: #f7f489;
}
.city1 {
  //
  width: 300px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  border: 5px solid #ffc34b;
  top: 20px;
  z-index: 1;
  left: 42px;
  border-radius: 12px;
  font-size: 18px;
}
//  <div class="listBox">
//             <div class="listItem">
.listBox {
  display: none;
  width: 150px;
  position: absolute;
  z-index: 1;
  top: 345px;
  left: 110px;
  border-radius: 12px;
  font-size: 14px;
  border: 5px solid #ffc34b;
  background-color: #2c3e50;
}
.listItem {
  margin: 10px 0;
}
.listItem span {
  margin-left: 10px;
}

.listItem img {
  width: 35px;
  height: 30px;
  position: absolute;
  left: 5px;
}
.tips {
  font-size: 30px;
  cursor: pointer;
  color: aqua;
  margin-left: 20px;
}
.tipsBox{
  // position: fixed;
  // left: 96px;
  // top: 20px;
  display: flex;
  align-items: center;
}
.datetime {
  width: 255px;
  z-index: 2;
  margin-left: 15px;
  // padding-right: 24px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  span {
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    line-height: 80px;
  }
}
.back {
  z-index: 2;
  text-align: left;
  box-sizing: border-box;
  // width: 300px;
  button {
    background: transparent;
    border: 0;
  }
}

.stationSelect {
  z-index: 2;
  position: relative;
  margin-left: 15px;
  width: 255px;
}

::v-deep .el-select .el-input .el-select__caret{
  color: #c0c4cc00;
}
::v-deep .el-input__inner{
  background-color: #fff0;
  color: #08fbfb;
  border: 1px solid #08fbfb;
  font-size: 24px;
}
</style>
